import React, { useState, useEffect } from "react"
import "./styles.scss"
import check from './../../../images/check-ico.svg'
import checkWhite from './../../../images/check-white-ico.svg'
import ModalMessage from '../../modal-message/ModalMessage';
import info from './../../../images/i-ico.svg'

export default props => {
    let [ error, setError ] = useState(false);
    let [ load, setLoad ] = useState(false);
    let [ activeModal, setActiveModal ] = useState(false);

    useEffect(() => {
        if ( !load && props.val ) {
            setLoad(true);
        }
        setLoad(true);
    }, [load])

    const onClickA = () => {
        let click = document.getElementById(props.onclickItemID);
        if(click) {
            click.onclick = function(e) {
                props.setShowMore(!props.showMore);
            }
        }
    }

      useEffect(() => {
            if ( props.forceValidate ) {
                if ( props.required && !props.val) {
                    setError(true);
                }
                if ( props.required && props.val ) {
                    setError(false)
                }
            } else {
                if ( load && props.required && !props.val) {
                    setError(true);
                }
                if ( load && props.required && props.val ) {
                    setError(false)
                }
            }

      }, [props.val, props.forceValidate])

      useEffect(() => {
        if(props.reset) {
            setError(false);
        }
      }, [props.reset])

      if(load && props.onclickItemID) {
        onClickA();
      }

      useEffect(() => {
        if(load && props.onclickItemID) {
            onClickA();
        }
      }, [props.showMore])
      
    return (
        <div className={"checkbox " + ( error ? 'error error-item' : ' ' ) + ( props.class ? props.class : '')}>
            <div className="check" onClick={ () => props.setFunction(!props.val) } id={props.id ? props.id : ''} data-value={props.val}>
                { props.val && 
                    <>
                        { props.checkWhite &&
                            <img src={ checkWhite } alt="Zaznaczony"/>
                        }
                        { !props.checkWhite &&
                            <img src={ check } alt="Zaznaczony"/>
                        }
                   </>
                }
            </div>
            {/* (props.required ? "*" : "") +  */}
            <div className="text-editor" dangerouslySetInnerHTML={ {__html: props.text} } />
            {/* {props.showMore &&
                <p className="more-or-less" onClick={() => props.setShowMore(true)}>Zobacz pełną treść.</p>
            } */}
            { props.tip && 
                <img src={ info } className="tip" alt="informacja" onClick={ () => setActiveModal( true )} />
            }
            { activeModal &&
                <ModalMessage closeModal={ () => setActiveModal(false) } 
                            button={ props.button } 
                            buttonClass="blue" 
                            buttonTitle={ props.buttonTitle }
                            buttonArrow={ true } 
                            tipHeader={ props.tipHeader }
                            tipText={ props.tipText } />
            }
            { error && 
                <div className="error-message">
                    Required
                </div>
            }
        </div>
  )
}
